import axios from '@fs/zion-axios'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../useNotifications'

/**
 * Hook for fetching information about an artifact’s comments’ discussion (comment count, and discussion ID)
 * This info is used to then open the discussions admin tool, where comments can be managed
 * @param {number} artifactId ID to fetch
 * @returns {Object} object with loading boolean, error status/data, artifact object, and refetch function
 */
const useArtifactDiscussion = (artifactId) => {
  const { t } = useTranslation()
  const [shouldFetch, setShouldFetch] = useState(true)
  const [discussion, setDiscussion] = useState(null)
  const { error } = useNotifications()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(`/service/tree/discussions/discussions`, {
          params: {
            productKey: 'Photos',
            systemTag: `artifact-${artifactId}`,
          },
        })
        if (data.discussions.length > 0) {
          setDiscussion(data.discussions[0])
        }
      } catch (err) {
        error(t('hooks.errors.retrievingArtifactDiscussion', `Error retrieving artifact discussion`), err)
      }
      setShouldFetch(false)
    }
    if (shouldFetch) {
      fetchData()
    }
  }, [shouldFetch, artifactId, error, t])

  const refetch = () => setShouldFetch(true)
  // Refetch whenever artifactId changes
  useEffect(() => refetch(), [artifactId])

  return {
    discussion,
  }
}

export default useArtifactDiscussion
